import { cva } from "cva";

export const carouselItemStyles = cva({
  base: "min-w-0 shrink-0 grow-0 basis-[calc(100vw-51px)] md:basis-400 flex",
  variants: {
    loop: {
      true: "mr-16 lg:mr-xl",
      false: "mr-16 lg:mr-xl last:mr-site-margin first:ml-site-margin",
    },
  },
  defaultVariants: {
    loop: false,
  },
});
